import { render, staticRenderFns } from "./General.vue?vue&type=template&id=06cc819c&scoped=true&lang=pug&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.scss?vue&type=style&index=0&id=06cc819c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc819c",
  null
  
)

export default component.exports